import { configureStore } from '@reduxjs/toolkit';

import appSlice from './appSlice';

const combinedReducer = {
  app: appSlice,
};

export default configureStore({
  reducer: combinedReducer,
});
